import { ReactNode } from "react"
import { useTranslation } from "react-i18next"
import Button from "@mui/material/Button"

import BasicButton from "@/components/button/BasicButton"
import Icon from "@/components/icon/Icon"

interface Props {
  onAddToken: (token: string) => void
  onClear: () => void
  onBackspace: () => void
}

interface Operator {
  icon: ReactNode
  value: string
}

const ICON_SIZE = 22

const OPERATORS: Operator[] = [
  { icon: <Icon type="add" size={ICON_SIZE} />, value: " + " },
  { icon: <Icon type="subtract" size={ICON_SIZE} />, value: " - " },
  { icon: <Icon type="close" size={ICON_SIZE} />, value: " * " },
  { icon: <Icon type="divide" size={ICON_SIZE} />, value: " / " },
  {
    icon: (
      <img src="/images/ico-parenthesis-open.svg" width={ICON_SIZE} height={ICON_SIZE} alt="(" />
    ),
    value: " ( ",
  },
  {
    icon: (
      <img src="/images/ico-parenthesis-close.svg" width={ICON_SIZE} height={ICON_SIZE} alt=")" />
    ),
    value: " ) ",
  },
]

const NUMBERS = ["7", "8", "9", "4", "5", "6", "1", "2", "3", "0", "."]

export default function CalculatorPad({ onAddToken, onClear, onBackspace }: Props) {
  const { t } = useTranslation()

  return (
    <div className="CalculatorPadCont">
      {/* Clear, Backspace 버튼 */}
      <div className="clear-row">
        <BasicButton type="default-outlined" size="md" onClick={onClear}>
          <Icon type="reset" size={20} />
          {t("button.clear")}
        </BasicButton>
        <BasicButton type="default-outlined" size="md" onClick={onBackspace}>
          <Icon type="arrow-line-left" size={20} />
        </BasicButton>
      </div>

      {/* 연산자 */}
      <div className="operator-grid">
        {OPERATORS.map(({ icon, value }) => (
          <Button
            key={value}
            variant="outlined"
            onClick={() => onAddToken(value)}
            className="calc-btn operator">
            {icon}
          </Button>
        ))}
      </div>

      {/* 숫자 */}
      <div className="number-grid">
        {NUMBERS.map((num) => (
          <Button
            key={num}
            variant="outlined"
            onClick={() => onAddToken(num)}
            className={`calc-btn number ${num === "0" ? "zero-btn" : ""}`}>
            {num}
          </Button>
        ))}
      </div>
    </div>
  )
}
